import { Button, message, Modal } from "antd";
import { useRef, useState } from "react";
import { api } from "../../../utils/api";

export const ResendDownloadJobEmailButton = ({
  licenseId,
}: {
  licenseId: number;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const isSubmittingRef = useRef(false);

  const handleSubmit = () => {
    if (isSubmittingRef.current) return;

    isSubmittingRef.current = true;
    setIsOpen(false);
    message.info(
      "システムでメール送信の準備を進めています。メールは数分後（2〜3分後）に送信されます。",
    );

    api
      .post(`api/admin/app-download-jobs/${licenseId}/resend-app-download-email`)
      .catch((e) => {
        console.error("Failed to resend download email", e);
      })
      .finally(() => {
        isSubmittingRef.current = false;
      });
  };

  return (
    <>
      <Button
        className="base-button-outline w-[66px] h-[41px]"
        onClick={() => setIsOpen(true)}
      >
        再送信
      </Button>
      <Modal
        open={isOpen}
        onOk={handleSubmit}
        onCancel={() => setIsOpen(false)}
        okText="送信"
        cancelText="キャンセル"
        closeIcon={false}
        width={389}
        className="custom-modal-resend-download-app"
        footer={() => (
          <div className="flex justify-center gap-[10px] mt-4">
            <Button
              onClick={() => setIsOpen(false)}
              className="base-button-outline w-[101px] h-[32px]"
            >
              いいえ
            </Button>
            <Button
              onClick={handleSubmit}
              className="base-button w-[101px] h-[32px]"
            >
              はい
            </Button>
          </div>
        )}
      >
        <p className="mb-0 font-medium text-xl text-center">
          RecOrbのダウンロードリンクを再送信しますか。
        </p>
      </Modal>
    </>
  );
};
